var __awaiter = this && this.__awaiter || function (p14991, p14992, p14993, p14994) {
  function f2082(p14995) {
    if (p14995 instanceof p14993) {
      return p14995;
    } else {
      return new p14993(function (p14996) {
        p14996(p14995);
      });
    }
  }
  return new (p14993 ||= Promise)(function (p14997, p14998) {
    function f2083(p14999) {
      try {
        f2085(p14994.next(p14999));
      } catch (e159) {
        p14998(e159);
      }
    }
    function f2084(p15000) {
      try {
        f2085(p14994.throw(p15000));
      } catch (e160) {
        p14998(e160);
      }
    }
    function f2085(p15001) {
      if (p15001.done) {
        p14997(p15001.value);
      } else {
        f2082(p15001.value).then(f2083, f2084);
      }
    }
    f2085((p14994 = p14994.apply(p14991, p14992 || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const urlParse = require("url-parse");
const storage = window.currentStorage;
class ClientManager {
  constructor(p15002, p15003, p15004) {
    this.matchmakerAddress = p15002;
    this.availableRegions = p15003;
    this.dedicatedOnlyRegions = p15004;
    this.cachePingRegion = true;
    this.enableLogging = !!storage.getItem("CLIENT_MANAGER_LOGGING");
  }
  get hostname() {
    return storage.__HOSTNAME__ || (ClientManager.USE_PORT ? location.host : location.hostname);
  }
  seek(seekData) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Seeking games...");
      let v12173 = storage.__REGION__ || seekData.regionId || (yield this.getRegion());
      let v12174 = seekData.gameId || this.parseQuery();
      let v12175 = yield this.matchmakerSeek(v12173, v12174, seekData.dataQuery || null, seekData.autoChangeGame, seekData.validationToken, seekData.captchaToken);
      if (!seekData.skipReplaceState) {
        window.history.replaceState(document.title, document.title, this.generateHref(v12175.gameId));
      }
      return v12175;
    });
  }
  getRegion() {
    return __awaiter(this, undefined, undefined, function* () {
      return new Promise((p15006, p15007) => __awaiter(this, undefined, undefined, function* () {
        let v12176 = storage.getItem(ClientManager.PING_REGION_CACHE_KEY);
        if (v12176 && this.availableRegions.indexOf(v12176) != -1) {
          p15006(v12176);
          return;
        }
        let v12177 = yield this.fetchPingList();
        let vLN02065 = 0;
        let v12178 = false;
        for (let v12179 in v12177) {
          if (this.availableRegions.indexOf(v12179) == -1) {
            continue;
          }
          if (this.dedicatedOnlyRegions.indexOf(v12179) >= 0) {
            continue;
          }
          let v12180 = v12177[v12179];
          let v12181 = v12180.endsWith(":443") ? "https:" : "http:";
          fetch(v12181 + "//" + v12180 + "/ping").then(() => {
            if (!v12178) {
              ClientManager.setDefaultRegion(v12179);
            }
            v12178 = true;
            p15006(v12179);
          }).catch(p15008 => {
            vLN02065++;
            if (vLN02065 >= Object.keys(v12177).length) {
              p15007("All pings failed.");
            }
          });
        }
      }));
    });
  }
  getRegionPing() {
    return __awaiter(this, undefined, undefined, function* () {
      return new Promise((p15009, p15010) => __awaiter(this, undefined, undefined, function* () {
        let v12182 = yield this.fetchPingList();
        let vO384 = {};
        let vO385 = {};
        let v12183 = false;
        for (let v12184 in v12182) {
          let v12185 = v12182[v12184];
          let v12186 = v12185.endsWith(":443") ? "https:" : "http:";
          vO385[v12184] = Date.now();
          fetch(v12186 + "//" + v12185 + "/ping").then(() => {
            vO384[v12184] = Date.now() - vO385[v12184];
            if (Object.keys(vO384).length >= Object.keys(v12182).length) {
              p15009(vO384);
            }
          }).catch(p15011 => {
            vO384[v12184] = -1;
            if (Object.keys(vO384).length >= Object.keys(v12182).length) {
              p15009(vO384);
            }
          });
        }
      }));
    });
  }
  switchGame(p15012, p15013) {
    if (!p15013) {
      window.location.href = this.generateHref(p15012);
    }
  }
  static setDefaultRegion(p15014) {
    storage.setItem(ClientManager.PING_REGION_CACHE_KEY, p15014);
  }
  parseQuery() {
    this.log("Parsing query...");
    var vVP14990 = urlParse(location.href, true);
    var v12187 = vVP14990.query.game;
    if (typeof v12187 == "string") {
      return v12187;
    } else {
      return null;
    }
  }
  fetchPingList() {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Fetching list of servrs to ping...");
      return yield this.matchmakerRequest("/ping-list", {
        hostname: this.hostname
      });
    });
  }
  fetchGameList() {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Fetching game list...");
      return yield this.matchmakerRequest("/game-list", {
        hostname: this.hostname
      });
    });
  }
  fetchGameInfo(p15015) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Fetching game info for " + p15015 + "...");
      return yield this.matchmakerRequest("/game-info", {
        game: p15015
      });
    });
  }
  matchmakerSeek(p15016, p15017 = null, p15018, p15019 = true, p15020, p15021 = null) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Seeking matchmaker with region " + p15016 + "...");
      let vO386 = {
        hostname: this.hostname,
        region: p15016,
        autoChangeGame: p15019,
        validationToken: p15020
      };
      if (p15017) {
        vO386.game = p15017;
      }
      if (p15018) {
        vO386.dataQuery = JSON.stringify(p15018);
      }
      if (p15021) {
        vO386.captchaToken = p15021;
      }
      return yield this.matchmakerRequest("/seek-game", vO386);
    });
  }
  generateHref(p15022) {
    if (!ClientManager.MERGE_QUERY) {
      return "/?game=" + p15022;
    }
    const v12188 = new URLSearchParams(window.location.search);
    v12188.set("game", p15022);
    const v12189 = v12188.toString().replace(/%3A/g, ":");
    return "/?" + v12189;
  }
  matchmakerRequest(p15023, p15024 = {}, p15025 = {}) {
    return __awaiter(this, undefined, undefined, function* () {
      this.log("Executing matchmaker request " + p15023 + " with params " + JSON.stringify(p15024) + "...");
      for (let v12190 in p15024) {
        if (p15024[v12190] == null) {
          delete p15024[v12190];
        }
      }
      let v12191 = new URLSearchParams(p15024).toString();
      let v12192 = yield fetch("" + this.matchmakerAddress + p15023 + (v12191 ? "?" + v12191 : ""), {
        headers: new Headers(Object.assign({
          "accept-language": "en-US,en;q=0.6;"
        }, p15025))
      });
      if (v12192.ok) {
        return yield v12192.json();
      } else {
        let v12193 = null;
        try {
          v12193 = yield v12192.json();
        } catch (e161) {}
        let vO387 = {
          message: v12192.statusText,
          response: {
            data: v12193
          }
        };
        console.error("Matchmaker request error", vO387);
        throw vO387;
      }
    });
  }
  log(...iÎïîîiî) {
    if (this.enableLogging) {
      return (console.debug || console.info || console.log)(...iÎïîîiî);
    } else {
      return undefined;
    }
  }
}
exports.default = ClientManager;
ClientManager.PING_REGION_CACHE_KEY = "sid-utils:ping-region";
ClientManager.USE_PORT = false;
ClientManager.MERGE_QUERY = false;
ClientManager.ERRORS = {
  InvalidKey: "InvalidKey",
  GameFull: "GameFull",
  InvalidClientId: "InvalidClientId",
  InvalidClientKey: "InvalidClientKey",
  InvalidGameId: "InvalidGameId",
  ClientAlreadyRegistered: "ClientAlreadyRegistered",
  ClientNotRegistered: "ClientNotRegistered",
  NoAvailableServers: "NoAvailableServers",
  NoMatchingServers: "NoMatchingServers",
  NoServersMatchQuery: "NoServersMatchQuery",
  InvalidHostname: "InvalidHostname",
  RecaptchaFailed: "RecaptchaFailed",
  AccountAlreadyPlaying: "AccountAlreadyPlaying",
  TooManyIPs: "TooManyIPs",
  InvalidClientValidationToken: "Socket Error",
  InvalidClientIP: "Socket Mismatch",
  ExpiredClientValidationToken: "Validation Error",
  InvalidClientValidationTokenData: "Data Error"
};